/**
 * Live countdown ticker. Updates a DOM element every second with the time
 * remaining until the next Mon–Fri 9am Melbourne cutover.
 */

import { formatCountdown, msUntilNextNineAm, nextNineAmMelbourne, melbourneAt } from './melbourne';

export function startCountdown(target: HTMLElement, prefix = 'Next '): () => void {
  let stopped = false;

  function tick() {
    if (stopped) return;
    const ms = msUntilNextNineAm();
    // When the next drop is more than 24h away we're in the weekend-skip
    // window; surface it in the label so "Next 31h 30m" reads clearly.
    const nextYmd = melbourneAt(nextNineAmMelbourne()).ymd;
    const [ny, nm, nd] = nextYmd.split('-').map((s) => parseInt(s, 10));
    const nextDow = new Date(Date.UTC(ny, nm - 1, nd)).getUTCDay();
    const isMondayDrop = nextDow === 1 && ms > 24 * 3600_000;
    const dowLabel = isMondayDrop ? 'Mon ' : '';
    target.textContent = `${prefix}${dowLabel}${formatCountdown(ms)}`;
    if (ms <= 0) {
      // Cutover hit — page should reload to fetch the new puzzle.
      target.textContent = `${prefix}now`;
      // Hard reload after 2s so the user sees the new puzzle.
      setTimeout(() => location.reload(), 2_000);
      return;
    }
    // Tick at most once a second; for human readability we don't need finer.
    const nextTickMs = ms < 60_000 ? 500 : 1_000;
    setTimeout(tick, nextTickMs);
  }

  tick();

  return () => {
    stopped = true;
  };
}
